import React from 'react'

const PhoneIncrease = ({ lightColor, darkColor, size }) => {
  const lightFill = lightColor ? lightColor : '#A0AEC0'
  const darkFill = darkColor ? darkColor : '#4A5568'
  
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 18 28"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g
        strokeWidth="1.5"
        fill="none"
        fillRule="evenodd"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path stroke={lightFill} d="M20.75 10.625l-.579-3.456-3.456.579" />
        <path
          d="M20.171 7.169l-3.384 4.745a.776.776 0 0 1-1.082.189L15.7 12.1l-1.87-1.333a.78.78 0 0 0-1.086.182l-3.064 4.3"
          stroke={lightFill}
        />
        <path
          d="M14.75 15.992v5.25a3 3 0 0 1-3 3h-7.5a3 3 0 0 1-3-3v-16.5a3 3 0 0 1 3-3h7.5a3 3 0 0 1 3 3M1.25 19.742h13.5"
          stroke={darkFill}
        />
      </g>
    </svg>
  )
}

export default PhoneIncrease
